export default __webpack_public_path__ + "static/role_4-0d7e308196ef9c0aec2e472cf689fe15.png";